/**
 * Masthead Search Modal
 */

const el = {
	container: document.querySelector('[data-js="masthead"]'),
	searchModal: document.querySelector('[data-js="search-modal"]'),
};

/**
 * Init this module.
 */
const init = () => {
	if (!el.container || !el.searchModal) {
		return;
	}
};

export default init;
